import { pointsDistance } from '../../utils/getDistance';
import cachedFetch from './cachedFetch';

function addDistance(points) {
  let lastPoint = null;
  let dist = 0;
  const fullPath = points.map(pt => {
    if (lastPoint) {
      dist += pointsDistance(pt, lastPoint);
    }
    lastPoint = pt;
    return { ...pt, dist };
  });
  // Reduce points to a minimum distance
  const minDistance = Math.max(30, dist / 100);
  let lastDistance = null;
  return fullPath.filter(pt => {
    if (lastDistance === null) {
      lastDistance = pt.dist;
      return true;
    }
    const keep = pt.dist - lastDistance > minDistance;
    if (keep) {
      lastDistance = pt.dist;
    }
    return keep;
  });
}

function getLegs(workingRoute) {
  return workingRoute && workingRoute.legs
    ? workingRoute.legs.map(id => workingRoute[id])
    : [];
}

function getPathFromLegs(legs) {
  const path = legs.flatMap(leg => leg.points);
  return path.length > 1 ? path : null;
}

function getPathFromCurrentRoute(currentRoute, location) {
  const expectedPath = currentRoute && `/route/${currentRoute.id}`;
  return location.pathname === expectedPath ? currentRoute.points : null;
}

function addDistanceAndElevation(points, orgPoints) {
  let lastElevation = null;
  let lastDistance = 0;
  let gradient = 0;
  let ascent = 0;
  return points.map(({ elevation, location }, idx) => {
    const distance = orgPoints[idx].dist;
    if (idx > 0) {
      const step = distance - lastDistance;
      gradient = (elevation - lastElevation) / step;
      ascent += Math.max(0, elevation - lastElevation);
    }
    lastDistance = distance;
    lastElevation = elevation;
    return { location, elevation, gradient, distance: distance / 1000, ascent };
  });
}

async function getPath(workingRoute, currentRoutes, location) {
  const legs = getLegs(workingRoute);
  const working = legs.some(leg => leg.routing !== 'travelmode/DONE');
  if (working) {
    return undefined;
  }
  const path =
    getPathFromLegs(legs) || getPathFromCurrentRoute(currentRoutes, location);
  if (!path) {
    return null;
  }
  const simplifiedPath = addDistance(path);
  const pathString = simplifiedPath.map(pt => `${pt.lat},${pt.lng}`).join('|');
  const link = `https://api.opentopodata.org/v1/aster30m?locations=${pathString}`;
  const elevations = await cachedFetch(link);
  return (
    elevations && addDistanceAndElevation(elevations.results, simplifiedPath)
  );
}

export default getPath;
